/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/sources/:source_id/preview_and_validate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateCacheKeys } from "./constants";
import type {
  PostIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateProps,
  PostIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateResult,
} from "./types";

export const postIntegrationsDirectCdiSourcesSourceIdPreviewAndValidate = reactQueryMutationAdapter(
  postIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateCacheKeys,
  (
    props: PostIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateProps
  ): Promise<PostIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateResult> => {
    const { sourceId, sqlQuery, dataType } = props;
    return fetch(
      `/integrations/direct/cdi/sources/${sourceId}/preview_and_validate`,
      "POST",
      { sql_query: sqlQuery, data_type: dataType },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
